<div class="bary-siret d-flex align-items-center">
  <div class="flex-grow-1">
    <div class="md-form md-outline">
      <jhi-bary-icon
        *ngIf="siretOk && _innerControl.touched && _innerControl.valid"
        icon="check-circle"
        [faDirective]="FAS"
        [title]="'components.siret.siretVerified' | translate"
        class="suffix text-success"
      ></jhi-bary-icon>
      <input
        mdbInput
        [mdbValidate]="true"
        [validateSuccess]="false"
        [formControl]="_innerControl"
        [name]="id"
        type="text"
        [id]="id"
        maxlength="254"
        class="form-control"
        [value]="_innerControl.value"
        [readOnly]="disabled"
        [class.disabled]="disabled || _innerControl.disabled"
        jhiMarkAsterisk
      />
      <label [for]="id" jhiTranslate="components.siret.label">Siret Number</label>
      <mdb-error *ngIf="_innerControl.invalid && (_innerControl.dirty || _innerControl.touched)">
        <span *ngIf="_innerControl.hasError('pattern')" jhiTranslate="components.siret.siretLength"></span>
        <span *ngIf="_innerControl.hasError('required')" jhiTranslate="ERROR.REQUIRED_FIELD"></span>
      </mdb-error>
      <div *ngIf="siretNotFound" class="alert alert-warning" role="alert">
        <span class="warning" jhiTranslate="components.siret.notFound"></span>
      </div>
      <div *ngIf="siretOk && _innerControl.valid" class="alert alert-success" role="alert">
        <span *ngIf="result.companyName" class="success" jhiTranslate="components.siret.companyFindWithName" [translateValues]="result"></span>
        <span class="success" *ngIf="!result.companyName" jhiTranslate="components.siret.companyFind" [translateValues]="result"></span>
      </div>
    </div>
  </div>
  <div class="flex-shrink-0 mx-3" *ngIf="searchButton">
    <jhi-bary-button icon="search" [label]="'components.siret.find' | translate" [disabled]="control!.invalid" (clickEvent)="find()"></jhi-bary-button>
  </div>
  <ngx-spinner name="siret-spinner"></ngx-spinner>
</div>
